import React, { Component } from 'react';
import { Radio, message } from 'antd';
import Cardedit  from './addBankCard';
import { getBankCards, setDefaultBankCard } from '@/api/wallet';

const clsPrefix = 'bankCard';
const RadioGroup = Radio.Group;
const radioStyle = {
  display: 'block',
  height: '50px',
  lineHeight: '50px',
};
const maskBankAccountNo = bankAccountNo => `**** **** **** **** ${bankAccountNo.slice(-4)}`;

class BankCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      defaultBankAccountNo: null,
      bankCards: [],
    }
  }

  componentDidMount() {
    getBankCards().then(bankCards => {
      const defaultBankCard = bankCards.filter(bankCard => bankCard.isDefault)[0] || {};
      this.setState({
        bankCards,
        defaultBankAccountNo: defaultBankCard.bankAccountNo
      });
    });
  }
  
  onChange = (e) => {
    const bankAccountNo = e.target.value;
    setDefaultBankCard(bankAccountNo).then(() => {
      message.info('设置成功');
      this.setState({
        defaultBankAccountNo: bankAccountNo,
      });
    });
  }

  handleAddNewBankCard = (newCard) => {
    this.setState({
      bankCards: [
        newCard,
        ...this.state.bankCards,
      ]
    })
  }
  
  render() {
    const { bankCards, defaultBankAccountNo } = this.state;
    return (
      <div className={clsPrefix}>
        <div className={`${clsPrefix}-tip`}>* 提现时使用选中的银行卡</div>
        <RadioGroup className={`${clsPrefix}-bankRadio`} onChange={this.onChange} value={defaultBankAccountNo}>
          {bankCards.map((item,index) => (
            <Radio key={index} style={radioStyle} value={item.bankAccountNo}>
            {item.bankName} {maskBankAccountNo(item.bankAccountNo)}
            </Radio>
          ))}
        </RadioGroup>
        <Cardedit onAdd={this.handleAddNewBankCard} />
      </div>
    );
    }
}
export default BankCard;